/* Krautz Ironz – ki-upsell.js (global geladen, layout/theme.liquid)
 *  1. „Passt dazu“ ([data-ki-upsell], snippets/ki-upsell.liquid): füllt bis data-limit mit Shopify-Empfehlungen auf
 *     (erst intent=complementary, dann related), gerendert über sections/ki-upsell-items.liquid.
 *  2. Ein-Klick-Hinzufügen ([data-ki-upsell-add] = Varianten-ID) per /cart/add.js; danach Drawer neu laden/öffnen.
 *  3. Live-Warenkorb: beobachtet jede POST-Anfrage an /cart/add|change|update|clear (Pursuit, KI, Apps – fetch und XHR)
 *     und ersetzt danach alle [data-ki-live]-Bereiche (Freiversand-Balken, „Passt dazu“) mit frischem HTML aus
 *     sections/ki-cart-live.liquid. Header-Zähler wird mit aktualisiert.
 * Nutzt window.KI (ki-theme.js) für Drawer und Zähler, wenn vorhanden.
 */
(function () {
  'use strict';
  if (window.KIUpsell) return;

  var R = window.routes || {};
  function rootUrl() { var r = R.rootUrl || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function recoUrl() { return R.productRecommendationsUrl || rootUrl() + 'recommendations/products'; }
  function cartAddUrl() { return (R.cartAddUrl || rootUrl() + 'cart/add') + '.js'; }
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Ansage für Screenreader ---------- */
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }

  /* ---------- 1. Empfehlungen nachladen ---------- */
  var recoCache = {};
  function fetchReco(pid, intent, limit) {
    var url = recoUrl() + '?product_id=' + encodeURIComponent(pid) + '&limit=' + limit + '&intent=' + intent + '&section_id=ki-upsell-items';
    if (!recoCache[url]) {
      recoCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return recoCache[url].then(function (html) {
      if (!html) return [];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return $$('[data-ki-upsell-reco] > li[data-pid]', doc);
    });
  }

  function fill(box) {
    if (box.__kiUps) return;
    box.__kiUps = true;
    var list = box.querySelector('[data-ki-upsell-list]');
    if (!list) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 4;
    if (box.getAttribute('data-reco') !== 'true' || list.children.length >= limit) {
      box.hidden = list.children.length === 0;
      return;
    }
    var ids = (box.getAttribute('data-source') || '').split(',').filter(Boolean).slice(0, 3);
    var seen = {};
    (box.getAttribute('data-exclude') || '').split(',').forEach(function (x) { if (x) seen[x] = 1; });
    $$('li[data-pid]', list).forEach(function (li) { seen[li.getAttribute('data-pid')] = 1; });
    var n = Math.min(10, limit + 4);

    /* abwechselnd aus jeder Quelle nehmen, damit jedes Warenkorb-Produkt etwas beiträgt */
    function add(groups) {
      var i = 0, more = true;
      while (more && list.children.length < limit) {
        more = false;
        for (var g = 0; g < groups.length && list.children.length < limit; g++) {
          if (i >= groups[g].length) continue;
          more = true;
          var li = groups[g][i], pid = li.getAttribute('data-pid');
          if (seen[pid]) continue;
          seen[pid] = 1;
          list.appendChild(document.importNode(li, true));
        }
        i++;
      }
    }
    Promise.all(ids.map(function (id) { return fetchReco(id, 'complementary', n); }))
      .then(function (groups) {
        add(groups);
        if (list.children.length >= limit) return;
        return Promise.all(ids.map(function (id) { return fetchReco(id, 'related', n); })).then(add);
      })
      .then(function () { box.hidden = list.children.length === 0; })
      .catch(function () { box.hidden = list.children.length === 0; });
  }

  function scan(scope) { $$('[data-ki-upsell]', scope || document).forEach(fill); }

  /* ---------- 2. Ein-Klick-Hinzufügen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ki-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-ki-upsell-add'), 10);
    var row = btn.closest('.ups-i');
    var title = row ? (row.querySelector('.ups-t') || {}).textContent : '';
    var inDrawer = !!btn.closest('#sidebar-cart');
    btn.disabled = true;
    btn.classList.add('is-busy');
    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Fehler');
          return j;
        });
      })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        announce('✓ ' + (title || '').trim());
        var K = window.KI || {};
        if (K.updateCartCount) K.updateCartCount();
        if (document.getElementById('sidebar-cart') && K.refreshAndOpenDrawer) {
          K.refreshAndOpenDrawer().then(function () {
            if (!inDrawer) return;
            var d = document.getElementById('sidebar-cart');
            if (d && d.focus) d.focus({ preventScroll: true });
          });
        } else if (document.body.classList.contains('template-cart')) {
          /* Warenkorb-Seite ohne Drawer: Artikelliste kommt aus Pursuits Formular → einmal neu laden */
          window.location.reload();
          return;
        }
        setTimeout(function () { btn.classList.remove('is-done'); btn.disabled = false; }, 1500);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.disabled = false;
        btn.title = err.message;
        announce(err.message);
      });
  });

  /* ---------- 3. Live-Warenkorb ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(?:[?#]|$)/;
  var DRAWER_RE = /[?&]view=drawer/;
  var timer = 0, lastDrawerRender = 0;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refreshLive, 220);
  }
  function refreshLive() {
    var K = window.KI || {};
    if (K.updateCartCount) K.updateCartCount();
    if (!document.querySelector('[data-ki-live]')) return;
    var skipDrawer = Date.now() - lastDrawerRender < 1500;
    fetch(rootUrl() + '?sections=ki-cart-live', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j['ki-cart-live']) return;
        var doc = new DOMParser().parseFromString(j['ki-cart-live'], 'text/html');
        $$('[data-ki-live]', doc).forEach(function (src) {
          var key = src.getAttribute('data-ki-live');
          $$('[data-ki-live="' + key + '"]').forEach(function (dst) {
            if (skipDrawer && dst.closest('#sidebar-cart')) return; /* Drawer wurde gerade ohnehin frisch gerendert */
            if (dst.innerHTML === src.innerHTML) return;
            dst.parentNode.replaceChild(document.importNode(src, true), dst);
          });
        });
        scan(document);
      })
      .catch(function () {});
  }

  function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || String(input || ''); }
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = urlOf(input);
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = origFetch.apply(this, arguments);
      if (method === 'POST' && CART_RE.test(url)) {
        p.then(function (r) { if (r && r.ok) schedule(); }).catch(function () {});
      } else if (DRAWER_RE.test(url)) {
        p.then(function () { lastDrawerRender = Date.now(); }).catch(function () {});
      }
      return p;
    };
  }
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kiCart = String(method).toUpperCase() === 'POST' && CART_RE.test(String(url));
    this.__kiDrawer = DRAWER_RE.test(String(url));
    return XO.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__kiCart) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) schedule(); });
    else if (this.__kiDrawer) this.addEventListener('load', function () { lastDrawerRender = Date.now(); });
    return XS.apply(this, arguments);
  };

  /* neu eingefügte Upsell-Blöcke (Drawer-Refresh durch Pursuit/KI) automatisch befüllen */
  var pending = 0;
  function onMutate() {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; scan(document); });
  }
  function boot() {
    scan(document);
    if ('MutationObserver' in window) new MutationObserver(onMutate).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  window.KIUpsell = { scan: scan, refresh: refreshLive };
})();
